<template>
    <layout>
        <map-component
            :id="mapId"
            ref="MapComponent"
            :url="url"
            :acl="acl"
            :mapTools="mapTools"
            :moduleCode="moduleCode"
            :showLoadingSpin="false"
            :activeExpandCollapse="activeExpandCollapse"
            :initialCollapsedExpandCollapse="initialCollapsedExpandCollapse"
            :enableLayerSwitcher="enableLayerSwitcher"
            :enableStreetView="enableStreetView"
            :enableBackoffice="enableBackoffice"
            :enableIdentify="enableIdentify"
            :enableScaleLine="enableScaleLine"
            :enableScaleBox="enableScaleBox"
            :enableMousePosition="enableMousePosition"
            :enableMeasure="enableMeasure"
            :enableCatalog="enableCatalog"
            :enableAnnotations="enableAnnotations"
            :enableAttribution="enableAttribution"
        >
        </map-component>

        <!-- Paineis -->
        <template v-slot:aside-control>
            <tool-layers
                :moduleCode="moduleCode"
                :showButtonOnActionMap="false"/>
            <tool-printvisible
                :moduleCode="moduleCode"
                :showButtonOnActionMap="false"/>
            <tool-regulations
                :moduleCode="moduleCode"
                :showButtonOnActionMap="false"/>

        </template>

    </layout>
</template>

<script>
    import layout from '../layouts/main.vue'
    import StoreMixin from '../shared/mixins/StoreMixin';
    import ModuleMixin from '../shared/mixins/ModuleMixin';
    import MapModuleMixin from '../shared/mixins/MapModuleMixin'

    export default {
        mixins: [
            ModuleMixin,
            StoreMixin,
            MapModuleMixin
        ],
        components: {
            layout,
            MapComponent: () => import(/* webpackChunkName: "map-component" */ '@/components/maps/MapComponent'),
            ToolLayers: () => import(/* webpackChunkName: "tool-layers" */ '@/app/shared/components/maps/tools/layers'),
            ToolPrintvisible: () => import(/* webpackChunkName: "tool-printvisible" */ '@/app/shared/components/maps/tools/printvisible'),
            ToolRegulations: () => import(/* webpackChunkName: "tool-regulations" */ '@/app/shared/components/maps/tools/regulations'),
        },
        provide: function() {
            return {
                closeAllMapPanel: this.closeAllMapPanel,
            }
        },
        data() {
            return {
                pageID: 'home',
                process: null,
            }
        },
        created() {

        },
        beforeDestroy() {
            this.closeAllPanels();
        },
        computed: {

        },
        methods: {
        },
        watch:
        {
        },
    }
</script>

<style scoped lang="scss">

</style>